import { Box } from "@chakra-ui/react";

export function FilterChip({ label, isActive, onClick }) {
  return (
    <Box
      as="button"
      onClick={onClick}
      w="100%"
      h="34px"
      px="10px"
      borderRadius="10px"
      border={isActive ? "1.5px solid #004a33" : "1.5px solid rgba(0,74,51,0.2)"}
      bg={isActive ? "#004a33" : "white"}
      color={isActive ? "#fc8f04" : "#004a33"}
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="5px"
      fontSize="11px"
      fontWeight="700"
      letterSpacing="0.01em"
      transition="all 0.15s"
      cursor="pointer"
      overflow="hidden"
      whiteSpace="nowrap"
      _hover={{
        bg: isActive ? "#006644" : "rgba(0,74,51,0.06)",
        borderColor: "#004a33",
        transform: "translateY(-1px)",
        boxShadow: "0 2px 8px rgba(0,74,51,0.12)",
      }}
      _active={{ transform: "scale(0.97)" }}
    >
      {isActive && (
        <Box as="span" fontSize="9px" flexShrink={0} lineHeight={1}>✓</Box>
      )}
      <Box as="span" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
        {label}
      </Box>
    </Box>
  );
}
